import { Box, CardMedia } from '@mui/material';
import { ScanStatus } from '../../../type';
import { useCallback, useContext } from 'react';
import { MediaErrorMessageAwareContext } from '../by-side/MediaErrorMessageAware';

type RemoteImageMessageProps = {
  url?: string;
  thumbnailUrl?: string;
  fileName?: string;
  scanStatus?: ScanStatus;
};

export const RemoteImageMessage = (props: RemoteImageMessageProps) => {
  const errorAwareContext = useContext(MediaErrorMessageAwareContext);
  const onError = useCallback(() => {
    if (errorAwareContext) {
      errorAwareContext.onError();
    }
  }, [errorAwareContext]);
  return (
    <Box>
      <CardMedia
        sx={{ borderRadius: 3, maxWidth: 500 }}
        component='img'
        image={props.thumbnailUrl ?? props.url}
        alt={props.fileName}
        onError={onError}
      />
    </Box>
  );
};
